import { Table } from '@melio/penny';
import { DeliveryPreference, PaymentIntent } from '@melio/platform-api';
import { useMelioIntl } from '@melio/platform-i18n';
import { useDateUtils } from '@melio/platform-utils';

import { DeliveryDateValue } from './components/DeliveryDateValue';

type DeliveryDateSelectCellProps = {
  paymentIntentId: PaymentIntent['id'];
  selectedDeliveryPreferenceType: PaymentIntent['selectedDeliveryPreferenceType'];
  effectiveDeliveryDate: PaymentIntent['effectiveDeliveryDate'];
  earliestDeliveryDate?: DeliveryPreference['earliestDeliveryDate'];
  onDeliveryDateSelect: (
    paymentIntentId: PaymentIntent['id'],
    date: NonNullable<PaymentIntent['deliveryDate']>
  ) => void;
  isLate: boolean;
  isDisabled: boolean;
};

export const DeliveryDateSelectCell = ({
  paymentIntentId,
  selectedDeliveryPreferenceType,
  effectiveDeliveryDate,
  earliestDeliveryDate,
  onDeliveryDateSelect,
  isLate,
  isDisabled,
}: DeliveryDateSelectCellProps) => {
  const { formatMessage } = useMelioIntl();
  const { createDate } = useDateUtils();

  return (
    <Table.DateCell
      excludeHolidays
      weekDays={[1, 2, 3, 4, 5]}
      minDate={earliestDeliveryDate || createDate()}
      onSelect={(date) => onDeliveryDateSelect(paymentIntentId, date)}
      placeholder={formatMessage('activities.batchPayments.screens.paymentIntentsTable.scheduledDateCell.placeholder')}
      data-testid={`${paymentIntentId}-delivery-date-cell`}
      isReadOnly={isDisabled}
      displayValue={
        effectiveDeliveryDate && (
          <DeliveryDateValue
            paymentIntentId={paymentIntentId}
            deliveryDate={effectiveDeliveryDate}
            selectedDeliveryPreferenceType={selectedDeliveryPreferenceType}
            isLate={isLate}
          />
        )
      }
    />
  );
};
